(() => {
  const locale = window.velora?.locale || document.documentElement.lang || 'fr-FR';
  const addDays = (start, days, businessOnly) => {
    const d = new Date(`${start}T12:00:00`);
    let left = Number(days) || 0;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      if (!businessOnly || (d.getDay() !== 0 && d.getDay() !== 6)) left--;
    }
    return d;
  };
  const parseDate = (iso) => iso ? new Date(`${String(iso).slice(0,10)}T12:00:00`) : null;
  const fmt = new Intl.DateTimeFormat(locale, { day:'numeric', month:'long', year:'numeric' });
  const rangeFmt = (a,b) => {
    if (!a || !b) return '';
    if (typeof fmt.formatRange === 'function') return fmt.formatRange(a,b);
    return `${fmt.format(a)} – ${fmt.format(b)}`;
  };

  function deliveryText(box, variant = {}) {
    if (!box) return '';
    const mode = variant.delivery_mode || box.dataset.mode || 'lead_time';
    const today = box.dataset.today || new Date().toISOString().slice(0,10);
    const business = box.dataset.excludeWeekends === 'true';
    if (mode === 'fixed_window') {
      const start = parseDate(variant.delivery_start_date || box.dataset.fixedStart);
      const end = parseDate(variant.delivery_end_date || box.dataset.fixedEnd);
      return start && end ? rangeFmt(start,end) : 'Échéance à définir';
    }
    if (mode === 'fixed_deadline') {
      const deadline = parseDate(variant.delivery_deadline || box.dataset.fixedDeadline);
      return deadline ? `Au plus tard le ${fmt.format(deadline)}` : 'Échéance à définir';
    }
    const min = Number(variant.delivery_min_days ?? box.dataset.minDays ?? 0);
    const max = Number(variant.delivery_max_days ?? box.dataset.maxDays ?? min);
    const start = addDays(today, min, business);
    const end = addDays(today, Math.max(max,min), business);
    return min === max ? fmt.format(end) : rangeFmt(start,end);
  }

  function setupProduct(section) {
    const json = section.querySelector('[data-product-variants]');
    if (!json) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch(e) { return; }
    const form = section.querySelector('form.product-form');
    if (!form) return;
    const idInput = form.querySelector('[data-variant-id]');
    const add = form.querySelector('[data-add-to-cart]');
    const addLabel = form.querySelector('[data-add-label]');
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-product-compare]');
    const delivery = section.querySelector('[data-delivery-commitment]');
    const deliveryOutput = section.querySelector('[data-delivery-output]');
    const deliveryProp = form.querySelector('[data-delivery-property]');
    const textureDialog = document.querySelector('[data-texture-dialog]');
    let currentVariant = variants.find(v => String(v.id) === String(idInput.value)) || variants[0];

    const selected = () => [...form.querySelectorAll('fieldset[data-option-index]')].map(group => group.querySelector('[data-option-value]:checked')?.value || '');
    const findVariant = () => {
      const values = selected();
      return variants.find(v => v.options.length === values.length && v.options.every((x,i) => String(x) === String(values[i])));
    };
    const updateDelivery = (variant) => {
      if (!delivery || !deliveryOutput) return;
      const text = deliveryText(delivery, variant);
      deliveryOutput.textContent = text;
      if (deliveryProp) deliveryProp.value = text;
    };
    const updateTexture = (variant) => {
      if (!textureDialog) return;
      const wrap = textureDialog.querySelector('[data-texture-image-wrap]');
      const title = textureDialog.querySelector('[data-texture-title]');
      const desc = textureDialog.querySelector('[data-texture-description]');
      if (title) title.textContent = variant?.title || '';
      if (desc && variant?.color_description) desc.textContent = variant.color_description;
      if (wrap && variant?.texture_macro) wrap.innerHTML = `<img src="${variant.texture_macro}" alt="${String(variant.title || '').replace(/"/g,'&quot;')}">`;
    };
    const updateMedia = (variant) => {
      if (!variant?.featured_image_url) return;
      section.querySelectorAll('[data-packshot-image]').forEach((image) => {
        image.removeAttribute('srcset');
        image.src = variant.featured_image_url;
      });
    };
    const updateVariant = (variant, push = true) => {
      currentVariant = variant;
      if (!variant) {
        idInput.value = '';
        add.disabled = true;
        addLabel.textContent = 'Combinaison indisponible';
        return;
      }
      idInput.value = variant.id;
      add.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'AJOUTER AU PANIER' : 'ÉPUISÉ';
      if (price && window.Velora?.formatMoney) price.textContent = window.Velora.formatMoney(variant.price);
      if (compare) { compare.textContent = variant.compare_at_price > variant.price && window.Velora?.formatMoney ? window.Velora.formatMoney(variant.compare_at_price) : ''; }
      form.querySelectorAll('fieldset[data-option-index]').forEach((group, index) => {
        const label = group.querySelector(`[data-option-current="${index}"]`);
        if (label) label.textContent = `— ${variant.options[index] || ''}`;
      });
      updateDelivery(variant);
      updateTexture(variant);
      updateMedia(variant);
      const mobilePrice = document.querySelector('[data-mobile-atc-price]');
      if (mobilePrice && window.Velora?.formatMoney) mobilePrice.textContent = window.Velora.formatMoney(variant.price);
      if (push && history.replaceState) {
        const u = new URL(location.href); u.searchParams.set('variant', variant.id); history.replaceState({}, '', u.toString());
      }
    };

    form.querySelectorAll('[data-option-value]').forEach(input => input.addEventListener('change', () => updateVariant(findVariant())));

    // Populate texture swatches from variant metafields when available.
    form.querySelectorAll('.option-chip--swatch input').forEach(input => {
      const idx = Number(input.dataset.optionIndex);
      const sample = variants.find(v => String(v.options[idx]) === String(input.value) && v.swatch_image);
      const circle = input.parentElement.querySelector('.option-chip__color');
      if (sample?.swatch_image && circle) { circle.style.backgroundImage = `url(${sample.swatch_image})`; circle.style.backgroundSize = 'cover'; circle.style.backgroundPosition = 'center'; }
    });

    const qtyHidden = form.querySelector('[data-quantity-hidden]');
    const qtyDisplay = form.querySelector('[data-quantity-display]');
    let quantity = 1;
    form.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { quantity = Math.max(1, quantity - 1); qtyHidden.value = quantity; qtyDisplay.textContent = quantity; });
    form.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { quantity += 1; qtyHidden.value = quantity; qtyDisplay.textContent = quantity; });

    form.querySelector('[data-texture-open]')?.addEventListener('click', () => { updateTexture(currentVariant); textureDialog?.showModal(); });
    document.querySelector('[data-texture-close]')?.addEventListener('click', () => textureDialog?.close());
    textureDialog?.addEventListener('click', e => { if (e.target === textureDialog) textureDialog.close(); });

    const mediaDialog = document.querySelector('[data-media-dialog]');
    section.querySelectorAll('[data-gallery-item]').forEach(item => item.addEventListener('click', e => {
      if (e.target.closest('video,model-viewer,iframe')) return;
      const img = item.querySelector('img');
      if (!img || !mediaDialog) return;
      const dialogImg = mediaDialog.querySelector('[data-media-dialog-image]');
      dialogImg.src = img.currentSrc || img.src; dialogImg.alt = img.alt || '';
      mediaDialog.showModal();
    }));
    document.querySelector('[data-media-dialog-close]')?.addEventListener('click', () => mediaDialog?.close());
    mediaDialog?.addEventListener('click', e => { if (e.target === mediaDialog) mediaDialog.close(); });

    const more = section.querySelector('[data-gallery-more]');
    more?.addEventListener('click', () => { section.querySelectorAll('.product-gallery__item--extra').forEach(el => el.hidden = false); more.hidden = true; });

    const mobileAtc = document.querySelector('[data-mobile-atc]');
    const mobileAtcButton = document.querySelector('[data-mobile-atc-button]');
    mobileAtcButton?.addEventListener('click', () => form.requestSubmit());
    if (mobileAtc && add) {
      const obs = new IntersectionObserver(entries => {
        if (window.innerWidth >= 990) { mobileAtc.classList.remove('is-visible'); mobileAtc.hidden = true; return; }
        const visible = !entries[0].isIntersecting;
        mobileAtc.hidden = !visible; mobileAtc.classList.toggle('is-visible', visible);
      });
      obs.observe(add);
    }

    updateVariant(currentVariant, false);
  }

  const setupAllProducts = (root = document) => {
    if (root.matches?.('[data-product-section]')) setupProduct(root);
    root.querySelectorAll?.('[data-product-section]').forEach(setupProduct);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAllProducts());
  } else {
    setupAllProducts();
  }
  document.addEventListener('shopify:section:load', (event) => setupAllProducts(event.target));
})();


/* VELORA product stability v3 - 2026-08-25 */
(() => {
  const SECTION_SELECTOR = '[data-product-section]';

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'fr-FR';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 0
    }).format(cents / 100);
  };

  const setup = (section) => {
    if (!section || section.dataset.veloraStable === 'true') return;

    const variantsNode = section.querySelector('script[type="application/json"]');
    if (!variantsNode) return;

    let variants;
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (_) {
      return;
    }

    if (!Array.isArray(variants) || !variants.length) return;
    section.dataset.veloraStable = 'true';

    const form = section.querySelector('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('input[name="id"]');
    const priceNode = section.querySelector('[data-product-price]');
    const compareNode = section.querySelector('[data-product-compare]');
    const submit = form?.querySelector('[type="submit"]');
    const galleryImages = [...section.querySelectorAll('[data-packshot-image]')];
    let mediaToken = 0;

    const applyVariant = (radio, updateUrl = true) => {
      const value = radio?.value;
      const variant = variants.find((item) => item.options?.includes(value));
      if (!variant) return;

      section.querySelectorAll('input[type="radio"][name^="options"]').forEach((input) => {
        input.checked = input === radio;
      });

      if (variantInput) variantInput.value = String(variant.id);
      if (priceNode) priceNode.textContent = money(variant.price);
      if (compareNode) {
        compareNode.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '';
        compareNode.hidden = !variant.compare_at_price;
      }

      const optionIndex = radio.dataset.optionIndex || '0';
      const current = section.querySelector(`[data-option-current="${optionIndex}"]`);
      if (current) current.textContent = `— ${value}`;

      if (submit) {
        submit.disabled = !variant.available;
        submit.setAttribute('aria-disabled', String(!variant.available));
      }

      if (variant.featured_image_url && galleryImages.length) {
        const token = ++mediaToken;
        const src = variant.featured_image_url;
        galleryImages.forEach((image, index) => {
          image.decoding = 'async';
          image.loading = index === 0 ? 'eager' : 'lazy';
          image.fetchPriority = index === 0 ? 'high' : 'low';

          const swap = () => {
            if (token !== mediaToken) return;
            if (image.getAttribute('src') !== src) image.setAttribute('src', src);
            image.removeAttribute('srcset');
          };

          if (index === 0) swap();
          else if ('requestIdleCallback' in window) requestIdleCallback(swap, { timeout: 500 });
          else setTimeout(swap, 50 * index);
        });
      }

      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({ variantId: variant.id }, '', url);
      }

      section.dispatchEvent(new CustomEvent('velora:variant-change', {
        bubbles: true,
        detail: { variant }
      }));
    };

    section.addEventListener('click', (event) => {
      const label = event.target.closest('label.option-chip--swatch');
      if (!label || !section.contains(label)) return;
      const radio = label.querySelector('input[type="radio"]');
      if (!radio || radio.disabled || radio.checked) return;
      event.preventDefault();
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }, true);

    section.addEventListener('change', (event) => {
      const radio = event.target.closest('input[type="radio"][name^="options"]');
      if (!radio || !section.contains(radio)) return;
      event.stopImmediatePropagation();
      applyVariant(radio, true);
    }, true);

    const requestedId = new URL(window.location.href).searchParams.get('variant');
    const requested = variants.find((item) => String(item.id) === requestedId);
    const initialValue = requested?.options?.[0];
    const initialRadio = initialValue
      ? [...section.querySelectorAll('input[type="radio"][name^="options"]')].find((input) => input.value === initialValue)
      : section.querySelector('input[type="radio"][name^="options"]:checked');

    if (initialRadio) applyVariant(initialRadio, false);
    section.querySelectorAll('.reveal-on-scroll').forEach((node) => node.classList.add('is-visible'));
  };

  const setupAll = (root = document) => root.querySelectorAll(SECTION_SELECTOR).forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAll(), { once: true });
  } else {
    setupAll();
  }

  document.addEventListener('shopify:section:load', (event) => setupAll(event.target));
  window.addEventListener('pageshow', () => setupAll());
})();


/* VELORA touch guard v4 - intercept before legacy variant listeners */
(() => {
  let lastPointerSelection = 0;

  const activate = (event) => {
    const label = event.target.closest?.('[data-product-section] label.option-chip--swatch');
    if (!label) return false;

    const radio = label.querySelector('input[type="radio"][name^="options"]');
    if (!radio || radio.disabled) return false;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return true;
  };

  document.addEventListener('pointerup', (event) => {
    if (event.pointerType === 'mouse') return;
    if (activate(event)) lastPointerSelection = Date.now();
  }, true);

  document.addEventListener('click', (event) => {
    if (Date.now() - lastPointerSelection < 700) {
      const label = event.target.closest?.('[data-product-section] label.option-chip--swatch');
      if (label) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      return;
    }
    activate(event);
  }, true);
})();
